import './mini-form.styles.css';
import Button from '../../../components/button/button.component';

const MiniForm = () => {
  return (
    <form className="mini-form">
        <h2 className="mini-form-title">
            از ما بپرسید
            <span className="mini-form-sub-title">
            اگر سوالی دارید، خوشحال می‌شویم به شما کمک کنیم. لطفاً پیام خود را ارسال کنید.
            </span>
        </h2>
        <input type="email" className="mini-form-input" placeholder="ایمیل"/>
        <input type="text" className="mini-form-input" placeholder="نام" />
        <textarea className="mini-form-text-area" placeholder="پیام"></textarea>
        <Button className='faq-button-title'>
            ارسال
        </Button>
    </form>
  )
}

export default MiniForm;
